import ApiClient from '../services/ApiClient'

export function useApiClient(): ApiClient {
  // Priority: runtime config (window.APP_ENV) for production, build-time env for local dev
  const runtimeUrl = window.APP_ENV?.API_URL;
  const isPlaceholder = !runtimeUrl || runtimeUrl.includes('__') || runtimeUrl === '';
  
  // Use runtime URL if valid, otherwise fall back to Vite build-time env for local dev
  const apiUrl = isPlaceholder 
    ? (import.meta.env.VITE_URL || '') 
    : runtimeUrl;
  
  console.log('API URL:', apiUrl, '(source:', isPlaceholder ? 'build-time' : 'runtime', ')');
  return new ApiClient(apiUrl);
}